import React, { memo } from "react"

import { IsArray, IsIsset } from "helpers/ValueTests"

import Widgets from "containers/Widgets"

const Content = memo( ({content, params}) => {
    if (IsIsset(params.user) && (!IsArray(content) || content.length == 0)) {
        return null
    }

    return content.map(( item, index ) => (
        <Widgets
            key={ index }
            allow_video_consultation={params.allow_video_consultation}
            allow_chat_consultation={params.allow_chat_consultation}
            user={params.user}
            has_moderator={params.has_moderator}
            { ...item }
        />
    ))
} )

export default Content